import React, { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { api, apiErr } from "@/lib/api";
import { useMeta } from "@/hooks/useMeta";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";

// Search-select for (re)assigning a lead to a Sales. Admin/Owner/Chief see every Sales;
// Manager sees only Sales in their own branch (useMeta already filters this via
// salesUsersForAssign). Reassigning notifies the newly-assigned Sales (handled by the
// existing PUT /leads/{id} endpoint — no new backend work needed for that part).
export default function AssignSalesDropdown({ lead, className = "" }) {
  const qc = useQueryClient();
  const { salesUsersForAssign } = useMeta();
  const [saving, setSaving] = useState(false);

  const assign = async (salesId) => {
    if (!salesId || salesId === lead.sales_id) return;
    setSaving(true);
    try {
      await api.put(`/leads/${lead.lead_id}`, { nama: lead.nama, sales_id: salesId });
      toast.success("Lead di-assign ke sales baru");
      qc.invalidateQueries();
    } catch (e) { toast.error(apiErr(e)); }
    finally { setSaving(false); }
  };

  const currentName = salesUsersForAssign.find((u) => u.user_id === lead.sales_id)?.name || lead.sales_name || null;

  return (
    <Select value={lead.sales_id || undefined} onValueChange={assign} disabled={saving}>
      <SelectTrigger data-testid="assign-sales-trigger" className={`bg-[#18181B] border-white/10 h-9 text-sm ${className}`}>
        <SelectValue placeholder="Belum di-assign">{currentName || "Belum di-assign"}</SelectValue>
      </SelectTrigger>
      <SelectContent className="bg-[#18181B] border-white/10">
        {salesUsersForAssign.map((u) => (
          <SelectItem key={u.user_id} value={u.user_id} data-testid={`assign-sales-opt-${u.user_id}`}>{u.name}</SelectItem>
        ))}
        {salesUsersForAssign.length === 0 && (
          <div className="px-2 py-2 text-xs text-zinc-500">Tidak ada sales tersedia{lead.branch_id ? " untuk cabang ini" : ""}</div>
        )}
      </SelectContent>
    </Select>
  );
}
